import { createVNode as a, mergeProps as i } from "vue";
import n from "../node_modules/@pf-ui/pf-icon-svg/es/asn/OpacityLoadingTwoTone.js";
import p from "../components/PfIcon.js";
const o = (t, r) => {
  const e = {
    ...t,
    ...r.attrs
  };
  return a(p, i(e, {
    icon: n
  }), null);
};
o.displayName = "OpacityLoadingTwoTone";
o.inheritAttrs = !1;
export {
  o as default
};
